<template>
  <vonap-window
    :modal="true"
    :visible="value"
    transition="dialog-scale-transition"
    title="New List"
    width="320px"
    height="182px"
    @close="close"
  >
    <v-layout row justify-center>
      <v-card>
        <v-container grid-list-xl text-xs-center style="width:302px;height:97px">
          <v-layout row wrap>
            <h3>{{ message }}</h3>
          </v-layout>
        </v-container>
        <v-card-actions>
          <div class="spacer"></div>
          <v-btn block color="primary" @click="close" :disabled="sending">
            NO
          </v-btn>
          <v-btn block :color="confirmColor" @click="save" :disabled="sending">
            <v-progress-circular indeterminate v-if="sending" />
            YES
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-layout>
  </vonap-window>
</template>
<script>
import axios from 'axios'
import {mapGetters} from 'vuex'
import VonapWindow from '@/components/VonapWindow'
import notification from '@/helpers/notification'

export default {
  name: 'DashboardBonCoupConfirmForm',
  components: {
    VonapWindow,
  },
  props: {
    value: {type: Boolean},
    asOfDate: {type: String},
  },
  data() {
    return {
      sending: false,
      confirmCreateList: false,
      reConfirmCreateList: false,
      confirmColor: 'primary',
      message: '',
    }
  },
  methods: {
    async save() {
      const response = await axios
        .get(
          '/api/report/MonthlyReportSendingList/existDataOnBonCoup?asOfDate=' + this.asOfDate,
          {},
        )
        .catch(() => {
          notification('Some error', 'error')
          this.sending = false
        })
      const result = response.data

      if ((!this.confirmCreateList || !this.reConfirmCreateList) && result.existData) {
        if (this.confirmCreateList) {
          this.confirmColor = 'warning'
          this.reConfirmCreateList = true
          this.message = `Are you really sure to replace all data for: ${this.asOfDate}`
        } else {
          this.confirmCreateList = true
          this.message = result.message
        }
      } else {
        await this.send()
      }
    },
    async send() {
      this.sending = true
      const response = await axios
        .post('/api/report/MonthlyReportSendingList/CreateNewList?asOfDate=' + this.asOfDate, {})
        .catch(() => {
          notification('Some error', 'error')
          this.sending = false
        })

      if (response.status == 200) {
        this.$emit('success')
        if (response.data != 'Ok') {
          notification(response.data)
        } else {
          notification('List create successfully')
        }
      }

      this.close()
    },
    close() {
      this.confirmColor = 'primary'
      this.message =
        'Create new list for ' + kendo.format('{0:MMMM}', new Date(this.asOfDate)) + '?'
      this.confirmCreateList = false
      this.reConfirmCreateList = false
      this.sending = false
      this.$emit('input', false)
    },
  },
  computed: {
    ...mapGetters({currentUsername: 'authentication/currentUsername'}),
  },
  watch: {
    asOfDate(newValue) {
      if (newValue) {
        this.confirmColor = 'primary'
        this.message =
          'Create new list for ' + kendo.format('{0:MMMM}', new Date(this.asOfDate)) + '?'
      }
    },
  },
}
</script>
